import React, { useEffect, useRef, useState } from "react";
import NoSearchitems from "../../components/NoSearchitems";
import { IoCopyOutline } from "react-icons/io5";
import SingleOrderView from "./SingleOrderView";
import { useParams } from "react-router-dom";
import axios from "axios";
import ImageLoading from "../../components/ImageLoading";
import { FaCheck } from "react-icons/fa6";

import { IoIosArrowDown } from "react-icons/io";
import { FiDownload } from "react-icons/fi";
import { handleDownloadFile } from "../../utils/handlers";
import DownloadLoadingModal from "../../components/DownloadLoadingModal";

function Credit({ singleOrderView, setSingleOrderView, creditTypeOd }) {
  const [filterValue, setFilterValue] = useState("all");
  const [searchValue, setSearchValue] = useState("");
  // const [singleOrderView, setSingleOrderView] = useState(false);
  const [copyArray, setCopyArray] = useState([]);
  const [imageLoading, setImageLoading] = useState(false);
  const [list, setList] = useState([]);
  const { id } = useParams();
  const [singleOrderId, setSingleOrderId] = useState("");
  const [openFilter, setOpenFilter] = useState(false);
  const [switchOd, setSwitchOd] = useState(
    creditTypeOd === "true" ? true : false
  );
  const [downloadLoading, setDownloadLoading] = useState(false);
  const divRef = useRef(null);
  const selectref = useRef(null);
  let timer = "";

  const handleFilter = (data) => {
    setSearchValue("");
    setFilterValue(data);
  };
  const dropDownFilters = [
    {
      value: "all",
      name: "All",
      line: true,
    },
    {
      value: "on_track",
      name: "On Track",
      line: true,
    },
    {
      value: "revoke_initiated",
      name: "Revoke Initiated",
    },
    {
      value: "revoked",
      name: "Revoke Completed",
    },
    {
      value: "revoke_failed",
      name: "Revoke Failed",
      line: true,
    },
    {
      value: "invoke_initiated",
      name: "Invoke Initiated",
    },

    {
      value: "invoked",
      name: "Invoke Completed",
    },

    {
      value: "invoke_failed",
      name: "Invoke Failed",
    },
  ];

  const diabledCopyStyle = {
    width: "15px",
    height: "15px",
    color: "#c6c6c6",
    backgroundColor: "#f3f3f3",
  };
  const enabledCopyStyle = {
    width: "15px",
    height: "15px",
    color: "#00394d",
    backgroundColor: "#ffffff",
  };
  const fetchOrders = async (controller) => {
    setImageLoading(true);
    const token = localStorage.getItem("token");
    const options = {
      method: "GET",
      headers: { Authorization: token },
      signal: controller.signal,
    };
    let url;
    if (switchOd) {
      url = `${process.env.REACT_APP_URL}/lender/v1/orders?id=${id}&loan_type=overdraft_loan&filterd_list=${filterValue}&filter_reference_no=${searchValue}`;
      if (filterValue === "all") {
        url = `${process.env.REACT_APP_URL}/lender/v1/orders?id=${id}&loan_type=overdraft_loan&filter_reference_no=${searchValue}`;
      }
      // setList([
      //   {
      //     uuid: "5adfa4e8-2dc8-47ab-8354-0d452d434565",
      //     user_uuid: "a868edcb-9462-40be-a0a6-4487698f5009",
      //     order_reference_no: "284137",
      //     loan_status: "Not Disbursed",
      //     action_status: {
      //       status: "Revoke Completed",
      //       date: "01-08-2024",
      //       buttons: [],
      //     },
      //     current_outstanding: "21.63",
      //     prepayment_link: null,
      //   },
      // ]);
      // setCopyArray([]);
      // setImageLoading(false);
    } else {
      url = `${process.env.REACT_APP_URL}/lender/v1/orders?id=${id}&loan_type=term_loan&filterd_list=${filterValue}&filter_reference_no=${searchValue}`;
      if (filterValue === "all") {
        url = `${process.env.REACT_APP_URL}/lender/v1/orders?id=${id}&loan_type=term_loan&filter_reference_no=${searchValue}`;
      }
    }
    try {
      const res = await axios.request(url, options);
      setList(res.data.user_data);
      setCopyArray(res.data.user_data.map(() => false));
      setImageLoading(false);
      // setRowsPerPage(res.data.user_details.length);
    } catch (error) {
      console.log(error);
    } finally {
    }
  };
  function formatString(str) {
    // Replace underscores with spaces
    let formattedStr = str.replace(/_/g, " ");

    // Capitalize the first letter of each word
    formattedStr = formattedStr.replace(/\b\w/g, function (char) {
      return char.toUpperCase();
    });
    if (formattedStr === "Revoked") return "Revoke Completed";
    if (formattedStr === "Invoked") return "Invoke Completed";
    if (formattedStr === "Ninety Dpd") return "90 DPD";

    return formattedStr;
  }
  const setActionStatus = (status) => {
    const formatted = formatString(status);
    return formatted;
  };
  const setOrderColor = (status) => {
    const failedStatuses = [
      "Loan Not Disbursed",
      "Invoke Failed",
      "Revoke Failed",
      "Market Invoke",
      "Overdue EMI",
      "90 DPD",
      "failed",
      "Failed",
      "Margin Call",
    ];
    const initiatedStatuses = [
      "Revocation Initiated",
      "Invocation Initiated",
      "Invoke Initiated",
      "Revoke Initiated",
    ];

    if (failedStatuses.includes(status)) {
      return "bg-[#d30d00]";
    }
    if (initiatedStatuses.includes(status)) {
      return "bg-[#d3bf05]";
    }
    return "bg-[#0ba300]";
  };

  function formatToIndianRupees(num) {
    // Convert the number to a string
    return num.toLocaleString("en-IN", {
      style: "currency",
      currency: "INR",
    });
  }
  const handleCopy = (link, index) => {
    if (!document.hasFocus()) {
      return;
    }
    if (link === undefined || link === null) return;
    clearTimeout(timer);
    navigator.clipboard.writeText(link);
    const temArr = list?.map(() => false);
    temArr[index] = true;
    setCopyArray(temArr);
  };
  useEffect(() => {
    const controller = new AbortController();
    fetchOrders(controller);
    return () => {
      controller.abort();
    };
  }, [filterValue, searchValue, switchOd]);

  useEffect(() => {
    let timer1 = setTimeout(() => {
      setCopyArray(list?.map(() => false));
    }, 3000);

    return () => {
      clearTimeout(timer1);
    };
  }, [copyArray]);

  const handleClickOutside = (event) => {
    if (selectref.current && selectref.current.contains(event.target)) {
      return;
    }
    if (divRef.current && !divRef.current.contains(event.target)) {
      setOpenFilter(false);
    }
  };

  //report download
  const handleExcelDownload = async (id) => {
    setDownloadLoading(true);
    const token = localStorage.getItem("token");
    try {
      const options = {
        url: `${process.env.REACT_APP_URL}/lender/v1/orders/${id}/individual_user_lamf_report`,
        method: "GET",
        headers: { Authorization: token },
      };
      const res = await axios(options);
      // console.log(res);

      if (res.data.download_url.data) {
        handleDownloadFile(res.data.download_url.data);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setDownloadLoading(false);
    }
  };
  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <>
      {!singleOrderView && (
        <>
          {" "}
          <div className=" mt-4 w-full  h-[calc(100vh-190px)]  bg-white rounded-lg py-4 ">
            <div className=" w-full flex justify-between px-4 relative">
              {/* <div className="flex flex-row justify-start items-center">
                <div className="flex justify-between items-center mt-4 rounded-full w-fit bg-[#F1F1F6] py-0.5 px-0.5">
                  <button
                    className={`text-xs font-bold m-0.5 px-4 py-1.5 text-[#262626] ${
                      !switchOd ? "bg-[#A0FF77] rounded-full" : ""
                    }`}
                    onClick={() => setSwitchOd(false)}
                  >
                    Term Loan
                  </button>
                  <button
                    className={`text-xs font-bold m-0.5 px-4 py-1.5 text-[#262626] ${
                      switchOd ? "bg-[#A0FF77] rounded-full" : ""
                    }`}
                    onClick={() => setSwitchOd(true)}
                  >
                    Overdraft Loan
                  </button>
                </div>
              </div> */}
              <div className="rounded-[23px] bg-[#F0F0F0] text-sm font-semibold text-[#000000] p-1 inline-block">
                <button
                  className={`${
                    switchOd ? "bg-[#92e86c]" : ""
                  } w-[180px] py-[7px] rounded-[19px]`}
                  onClick={() => setSwitchOd(true)}
                >
                  Overdraft Loan
                </button>
                <button
                  className={`${
                    !switchOd ? "bg-[#92e86c]" : ""
                  } w-[180px] py-[7px] rounded-[19px]`}
                  onClick={() => setSwitchOd(false)}
                >
                  Term Loan
                </button>
              </div>
              <div className="flex flex-row justify-end items-center gap-2">
                <input
                  type="search"
                  placeholder="Search by reference number "
                  value={searchValue}
                  onChange={(e) => setSearchValue(e.target.value)}
                  className=" w-[210px] text-xs h-8 border border-[#e0e0e0] rounded bg-[#f8f8f8] px-4 py-[14px]  focus:outline-none"
                />
                <button
                  ref={selectref}
                  onClick={() => setOpenFilter(!openFilter)}
                  className=" py-2 px-4 z-20 flex justify-between items-center bg-[#f8f8f8]  border border-[#656565] rounded-lg w-[172px] h-8 text-xs focus:outline-none font-semibold shadow-sm"
                >
                  {formatString(filterValue)}
                  <span>
                    <IoIosArrowDown
                      className=" transition-all ease-in-out duration-100"
                      style={{
                        transform: openFilter
                          ? "rotate(180deg)"
                          : "rotate(0deg)",

                        color: "#00394d",
                        width: 17,
                        height: 17,
                      }}
                    />
                  </span>
                </button>
              </div>
              {openFilter && (
                <div
                  ref={divRef}
                  className=" w-[172px] px-[3.5px] rounded-b-lg absolute top-8 right-4 z-10 bg-white pt-[12px] text-xs font-medium shadow-md  pb-2 "
                >
                  {dropDownFilters.map((data, index) => (
                    <div>
                      <button
                        key={index}
                        onClick={() => {
                          handleFilter(data.value);
                          setOpenFilter(false);
                        }}
                        className={` rounded w-full py-1 mt-1 px-4 ${
                          data.value !== filterValue && `hover:bg-[#e6ebed]`
                        }  h-6 flex items-center cursor-default ${
                          data.value === filterValue && `bg-[#a0ff77]`
                        }`}
                      >
                        {data.name !== "All" && (
                          <span
                            className={` w-[10px] h-[10px] rounded-full ${setOrderColor(
                              data.name
                            )} block mr-[10px]`}
                          ></span>
                        )}

                        {data.name}
                      </button>
                      {data.line && (
                        <div className=" w-[93%] bg-[#e2ecff] h-[0.5px] my-1 mx-auto"></div>
                      )}
                    </div>
                  ))}
                </div>
              )}
            </div>
            {imageLoading && (
              <div className="w-full h-[calc(100vh-260px)] flex items-center justify-center">
                <ImageLoading />
              </div>
            )}
            {!imageLoading && (
              <>
                <table className="w-full box-border  flex flex-col mt-4 h-[calc(100vh-260px)]">
                  <thead className="text-sm font-semibold">
                    <tr className="w-full flex items-center">
                      <th className="text-left pl-6 pr-4 pt-3 pb-2 w-[12%]">
                        No.
                      </th>
                      <th className={`text-left  w-[19%]`}>Reference No.</th>

                      <th className="text-left  w-[15%]">Loan Status</th>
                      <th className={`text-left w-[22%] ml-[4%]`}>
                        Action Status
                      </th>
                      <th className={`text-left w-[22%] pl-[5%] `}>
                        Current outstanding
                      </th>

                      <th className={`text-left w-[20%] pl-[7%] mr-1`}>
                        {switchOd ? "Downloads" : "Prepayment Link "}
                      </th>
                    </tr>
                  </thead>

                  <tbody
                    className={` overflow-auto max-h-[calc(100vh-100px)] ${
                      list.length === 0 ? " h-[calc(100vh-200px)]" : ""
                    }`}
                  >
                    {list.length === 0 && (
                      <>
                        <NoSearchitems />
                      </>
                    )}
                    {list?.map((data, index) => (
                      <tr
                        className={`cursor-pointer  text-xs font-medium w-full flex items-center hover:bg-[#e6ebed] h-[60px] ${
                          index % 2 === 0 ? "bg-[#f8f8f8]" : "bg-white"
                        } `}
                        onClick={() => {
                          setSingleOrderId(data.uuid);
                          setSingleOrderView(true);
                        }}
                      >
                        <td className="text-left pl-6 pr-4  w-[12%]">
                          {index + 1}
                        </td>
                        <td className={`text-left w-[19%] pt-3 pb-2`}>
                          {data.order_reference_no || "--"}
                        </td>
                        <td className="text-left  w-[15%]">
                          {" "}
                          <span
                            className={` rounded-[13px] px-2 py-1 ${
                              data?.loan_status === "Disbursed" ||
                              data?.loan_status === "Active"
                                ? "bg-[#edfff4] text-[#0ba300]"
                                : "bg-[#fff5f5] text-[#d30d00]"
                            }`}
                          >
                            {data.loan_status || "--"}
                          </span>
                        </td>
                        <td className={`text-left w-[22%] ml-[4%] `}>
                          {" "}
                          <div className=" border rounded-xl px-2 py-1 border-black inline-flex items-center mt-2 ">
                            <span
                              className={` w-[10px] h-[10px] rounded-full ${setOrderColor(
                                data.action_status.status
                              )} block mr-[10px]`}
                            ></span>{" "}
                            {data.action_status.status || "--"}
                          </div>
                          <p className="text-[10px] text-[#8b8b8b] mt-1 pl-2">
                            {data.action_status.date
                              ? `on ${data.action_status.date}`
                              : "--"}
                          </p>
                        </td>
                        <td className={`text-left w-[22%] pl-[5%]`}>
                          {" "}
                          {formatToIndianRupees(
                            Number(data.current_outstanding)
                          ) || "---"}
                        </td>

                        <td className={`text-left w-[20%]   pl-[7%] mr-1`}>
                          {switchOd && (
                            <button
                              onClick={(event) => {
                                event.stopPropagation();

                                handleExcelDownload(data?.uuid);
                              }}
                              className={` p-[4px] border  rounded 
                                    border-[#00304d] bg-white "
                                `}
                            >
                              <FiDownload style={enabledCopyStyle} />
                            </button>
                          )}
                          {!switchOd && (
                            <>
                              {!copyArray[index] && (
                                <>
                                  {" "}
                                  <button
                                    onClick={(event) => {
                                      event.stopPropagation();
                                      handleCopy(data.prepayment_link, index);
                                    }}
                                    className={` p-[4px] border  rounded ${
                                      data.prepayment_link === null
                                        ? "border-[#c6c6c6] bg-[#f3f3f3] cursor-default"
                                        : "border-[#00304d] bg-white "
                                    }`}
                                  >
                                    <IoCopyOutline
                                      style={
                                        data.prepayment_link === undefined ||
                                        data.prepayment_link === null
                                          ? diabledCopyStyle
                                          : enabledCopyStyle
                                      }
                                    />
                                  </button>
                                </>
                              )}
                            </>
                          )}
                          {copyArray[index] && (
                            <p
                              className="text-xs  font-medium  items-center text-[#47b971] border border-[#47b971] rounded-[4px] inline-flex bg-white px-[5px] py-[3px]"
                              onClick={(event) => event.stopPropagation()}
                            >
                              <span className=" mr-1">
                                <FaCheck />{" "}
                              </span>
                              Link Copied
                            </p>
                          )}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </>
            )}
          </div>
          {downloadLoading && <DownloadLoadingModal />}
        </>
      )}
      {singleOrderView && (
        <SingleOrderView
          closeOrder={setSingleOrderView}
          orderId={singleOrderId}
          userId={id}
          switchOd={switchOd}
        />
      )}
    </>
  );
}

export default Credit;
